import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import style from "./Profile.module.css";

export default function Profile() {
  const [checkStorage, setCheckStorage] = useState(
    localStorage.getItem("auth_token") ? true : false
  );
  const [userInfo, setUserInfo] = useState("");
  const [userPassword, setUserPassword] = useState({
    password: "",
    confirmPassword: "",
  });

  const [editActive, setEditActive] = useState(false);
  const [editPasswordActive, setEditPasswordActive] = useState(false);

  const [activeColor, setActiveColor] = useState(false);

  const hadnleInputName = (e) => {
    e.preventDefault();
    if (editActive) {
      setActiveColor(true);
      setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
    } else {
      setActiveColor(false);
    }
  };

  const hadnleInputPassword = (e) => {
    e.preventDefault();

    setUserPassword({ ...userPassword, [e.target.name]: e.target.value });
  };

  const handleInputUpdate = async (e) => {
    e.preventDefault();

    e.currentTarget.innerText = "Saving...";
    e.currentTarget.disabled = true;
    e.target.nextElementSibling.innerText = "";

    if (userInfo.name !== "") {
      const data = {
        name: userInfo.name,
        id: userInfo.id,
      };
      try {
        const response = await axios.post("/updateName", data);
        const userdata = {
          name: response.data.name,
          email: response.data.email,
          id: response.data.id,
        };
        const responseString = JSON.stringify(userdata);

        localStorage.setItem("user", responseString);
        setEditActive(false);
        setEditActive(false);
        toast.dismiss();
        toast.success("Name Updated Successfully", {
          closeOnClick: true,
          theme: "colored",
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error("Name is Required", {
        closeOnClick: true,
        theme: "colored",
      });
    }
  };

  const handleInputPasswordUpdate = async (e) => {
    e.preventDefault();

    if (userPassword.password.length < 7) {
      toast.dismiss();
      toast.warn("password should be at least 8 characters long", {
        closeOnClick: true,
        theme: "colored",
      });
    } else if (userPassword.password === userPassword.confirmPassword) {
      e.currentTarget.innerText = "Saving...";
      e.currentTarget.disabled = true;
      e.target.nextElementSibling.innerText = "";

      const data = {
        password: userPassword.password,
        id: userInfo.id,
      };
      try {
        const response = await axios.post("/updatePassword", data);
        setEditPasswordActive(false);
        setUserPassword({ password: "", confirmPassword: "" });
        toast.dismiss();
        toast.success("Password Updated Successfully", {
          closeOnClick: true,
          theme: "colored",
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.dismiss();
      toast.error("Password & Confirm Password are not Same", {
        closeOnClick: true,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    function handleStorage() {
      setCheckStorage(localStorage.getItem("auth_token") ? true : false);
    }
    window.addEventListener("storage", handleStorage);

    const responseString = localStorage.getItem("user");
    const response = JSON.parse(responseString);

    setUserInfo(response);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [checkStorage]);
  return (
    <>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="ms-2">Profile</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className={`container d-flex flex-column ${style.profileForm}`}>
          <div className=" position-relative">
            <label className="w-100">Name</label>
            <input
              type="text"
              className={`w-25 ${activeColor ? "text-dark" : ""}`}
              value={userInfo.name || ""}
              name="name"
              onChange={hadnleInputName}
              autoComplete="off"
            />

            {!editActive ? (
              <span className={`${style.profile_form_input_icon}`}>
                <FontAwesomeIcon
                  icon={faPencil}
                  className="text-info"
                  onClick={() => {
                    setActiveColor(true);
                    setEditActive(true);
                  }}
                />
              </span>
            ) : (
              <span>
                <button
                  className={`${style.btnSave}`}
                  onClick={handleInputUpdate}
                >
                  Save
                </button>
                <button
                  className={` ${style.btnCancel} `}
                  onClick={() => {
                    setActiveColor(false);
                    setEditActive(false);
                  }}
                >
                  Cancel
                </button>
              </span>
            )}
          </div>

          <div className="position-relative">
            <label className="w-100">Email</label>
            <input
              type="text"
              value={userInfo.email || ""}
              autoComplete="off"
              className=" w-25 disabled"
              readOnly
            />
          </div>

          <div className=" position-relative">
            {!editPasswordActive ? (
              <>
                <label className="w-100">Password</label>
                <input
                  type="password"
                  className={`w-25 `}
                  value="********"
                  autoComplete="off"
                  readOnly
                />
                <span className={`${style.profile_form_input_icon}`}>
                  <FontAwesomeIcon
                    icon={faPencil}
                    className="text-info"
                    onClick={() => {
                      setEditPasswordActive(true);
                    }}
                  />
                </span>
              </>
            ) : (
              <>
                <label className="w-100">Choose New Password</label>
                <input
                  type="password"
                  className="w-25 text-dark "
                  name="password"
                  value={userPassword.password || ""}
                  onChange={hadnleInputPassword}
                  autoComplete="off"
                />
                <label className="w-100">Confirm Password</label>
                <input
                  type="password"
                  className="w-25 text-dark"
                  name="confirmPassword"
                  value={userPassword.confirmPassword || ""}
                  onChange={hadnleInputPassword}
                  autoComplete="off"
                />
                <div>
                  <button
                    className={`${style.btnSave}`}
                    onClick={handleInputPasswordUpdate}
                  >
                    Save
                  </button>
                  <button
                    className={`${style.btnCancel}`}
                    onClick={() => {
                      setEditPasswordActive(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </Offcanvas.Body>
    </>
  );
}
